import { render, staticRenderFns } from "./PorProfissional.vue?vue&type=template&id=2be88a86"
import script from "./PorProfissional.vue?vue&type=script&lang=js"
export * from "./PorProfissional.vue?vue&type=script&lang=js"
import style0 from "./PorProfissional.vue?vue&type=style&index=0&id=2be88a86&prod&lang=css"
import style1 from "./PorProfissional.vue?vue&type=style&index=1&id=2be88a86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports